export const NODE_ANNOTATION_TYPES = {
  NOTE: 'noteNode',
  TILESET: 'tileset',
};

export const DELAY_NODE_TYPES = {
  DELAY_BASE: 'delayBaseNode',
  DELAY: 'delayNode',
  HOLD: 'holdNode',
  HOLD_UNTIL_REPLY: 'holdUntilReplyNode',
};

export const MODIFYFLOW_NODE_TYPES = {
  MODIFYFLOW_BASE: 'modifyFlowBaseNode',
  FIELDS_MATCH: 'fieldsMatchNode',
  AB_SPLIT: 'abSplitNode',
  ATTRIBUTE_SPLIT: 'attributeSplitNode',
};

export const SEND_ACTION_NODE_TYPES = {
  CHANNEL_OPT: 'channelOptimization',
  SEND_ACTION_BASE: 'sendActionBaseNode',
  SEND_EMAIL: 'sendEmailNode',
  SEND_EMBEDDED: 'sendEmbeddedNode',
  SEND_IN_APP: 'sendInAppNode',
  SEND_PUSH: 'sendPushNode',
  SEND_SMS: 'sendSMSNode',
  SEND_WEB_PUSH: 'sendWebPushNode',
  SEND_WHATSAPP: 'sendWhatsAppNode',
};

export const CONTACT_ACTION_NODE_TYPES = {
  CONTACT_ACTION_BASE: 'contactActionBaseNode',
  ADD_CONTACT: 'addContactNode',
  REMOVE_CONTACT: 'removeContactNode',
  CHANGE_CONTACT_FIELD: 'changeContactFieldNode',
  ADD_USER_TO_FB: 'addUserToFbNode',
  REMOVE_USER_FROM_FB: 'removeUserFromFbNode',
  UPDATE_CONTACT_WEBHOOK: 'updateContactWebhookNode',
  MODIFY_CHANNEL_SUBSCRIPTION: 'modifyChannelSubscriptionNode',
  MODIFY_MESSAGE_TYPE: 'modifyMessageTypeNode',
};

export const MISC_NODE_TYPES = {
  MISC_BASE: 'miscBaseNode',
  CALL_WEBHOOK: 'callWebhookNode',
  TRIGGER_WORKFLOW: 'triggerWorkflowNode',
};

export const NODE_TYPES = {
  BASE: 'baseNode',
  BASE_WITH_FOOTER: 'baseNodeWithFooter',
  BASE_WITH_NESTED_NODES: 'baseWithNestedNodes',
  START: 'startNode',
  ...DELAY_NODE_TYPES,
  ...MODIFYFLOW_NODE_TYPES,
  ...SEND_ACTION_NODE_TYPES,
  ...CONTACT_ACTION_NODE_TYPES,
  ...MISC_NODE_TYPES,
  ...NODE_ANNOTATION_TYPES,
};

export type NODE_TYPES = (typeof NODE_TYPES)[keyof typeof NODE_TYPES];

const nodeIntersection = Object.entries(NODE_TYPES).reduce(
  (acc, [key, val]) => {
    const isBase = key.includes('BASE');
    const bucket: { [key: string]: string } = isBase ? acc.base : acc.renderable;

    bucket[key] = val;

    return acc;
  },
  { base: {}, renderable: {} },
);

export const BASE_NODE_TYPES: Record<string, string> = nodeIntersection.base;
export const RENDERABLE_NODE_TYPES: Record<string, string> = nodeIntersection.renderable;

export const EDGE_TYPES = {
  DEFAULT: 'edgeConfig',
};

export const COMBO_TYPES = {
  DEFAULT: 'comboConfig',
};
